import React, { Suspense, lazy } from 'react';
import styled from 'styled-components';
import { searchTopId } from '../common/constants';

const LocationSitemapView = lazy(() => import('./locationSitemapView'));

export const LocationsSitemapWrapper = () => {
    return (
        <Container id={searchTopId}>
            <Suspense fallback={<div>Loading...</div>}>
                <LocationSitemapView />
            </Suspense>
        </Container>
    );
};

const Container = styled.div`
    background-color: #f6f6f6;
    margin-top: -18px;
`;